import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams, useLocation } from "react-router-dom";
import { Form, InputGroup, Col, Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import parse from "react-html-parser";
import moment from "moment";
import BaseLayout from "../../components/BaseLayout";
import Header from "../../components/Header";
import { listRsvpState } from "../../utils/constant";
import {
  CustomDialog,
  InformationDialog,
} from "../../components/DialogCollection";
import ApiUtils from "../../utils/api_utils";
import * as PageRoutes from "./../../utils/route_pages";
import * as Assets from "./../../utils/svg_assets";
import ReaderScan from "../../components/QrReader";
import ZoomModal from "../../components/ModalZoom/Zoom";

const EventDetail = (props) => {
  const { getDataById, postEventRsvp } = props;
  const { id } = useParams();
  const search = useLocation().search;
  const type = new URLSearchParams(search).get("type");
  const [data, setData] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalZoom, setShowModalZoom] = useState(false);
  const [showModalSuccess, setShowModalSuccess] = useState(false);
  const [payload, setPayload] = useState({});
  const [showQrReader, setShowQrReader] = useState(false);
  const [showPassNumber, setShowPassNumber] = useState("password");
  const [dataModal, setDataModal] = useState({
    isOpen: false,
    message: "",
  });

  const {
    name,
    start,
    end,
    address = "",
    contact_details: contactDetail = {},
    coordinates,
    payment_type: paymentType,
    description,
    thumbnail,
    rsvp_state: rsvpState,
    password_required: passwordRequired,
  } = data;

  const dataZoom = [
    {
      images: {
        img: {
          display: thumbnail,
        },
      },
    },
  ];

  useEffect(() => {
    getDataById(id).then((response) => {
      setData(response.data);
      setPayload({
        ...payload,
        state: setStateRsvp(
          type === "is_today" ? "attending" : response.data.rsvp_state
        ),
      });
    });
  }, []);

  const RenderEventDate = (props) => {
    const { type, date } = props;
    return (
      <div>
        <span className="mr-xs">{type}:</span>
        <span>{date}</span>
      </div>
    );
  };

  const SectionEventDate = () => {
    return (
      <div className="d-flex mb-2">
        <div className="mr-xs">
          <img src={Assets.iconClock} width={30} height={30} alt="Icon Clock" />
        </div>
        <div>
          <RenderEventDate
            type="Start"
            date={moment(start).format("DD MMM YYYY, h:mm")}
          />
          <RenderEventDate
            type="End"
            date={moment(end).format("DD MMM YYYY, h:mm")}
          />
        </div>
      </div>
    );
  };

  const getCoordinate = (data) => {
    if (data) {
      return `${data[1]},${data[0]}`;
    }
    return null;
  };

  const SectionLocation = () => {
    return (
      <div className="d-flex mb-2">
        <div className="mr-xs">
          <img
            src={Assets.iconPinMap}
            width={30}
            height={30}
            alt="Icon Pin Map"
          />
        </div>
        <div>
          <div>{parse(address)}</div>
          <div className="btn btn-danger w-auto">
            <a
              href={`https://www.google.com/maps/search/?api=1&query=${getCoordinate(
                coordinates
              )}`}
              className="text-white"
              target="_blank"
              rel="noreferrer"
            >
              Open Map
            </a>
          </div>
        </div>
      </div>
    );
  };

  const SectionBadgeSale = () => {
    return (
      <div className="d-flex mb-2">
        <div className="mr-xs">
          <img
            src={Assets.iconBadgeSale}
            width={30}
            height={30}
            alt="Icon Badge Sale"
          />
        </div>
        <div>{paymentType === 1 ? "Free" : "Paid"}</div>
      </div>
    );
  };

  const SectionEventDescription = () => {
    return (
      <div>
        <div className="text-danger fs-16">Event Description</div>
        <div className="p-2">
          <p>{parse(description)}</p>
        </div>
      </div>
    );
  };

  const HasLine = () => {
    return <hr className="no-container" />;
  };

  const SectionEventContactInformation = () => {
    const { email = null, name = null, phone = null } = contactDetail;

    return (
      <div className="mb-3">
        <div className="text-danger">Event Contact Information</div>
        <div className="d-flex align-items-center">
          <div className="mr-2 d-flex align-items-center">
            <img
              src={Assets.iconProfileActive}
              alt="icon Profile Active"
              width={50}
            />
          </div>
          <div>
            <div>{name}</div>
            <div>{email}</div>
            <div>{phone}</div>
          </div>
        </div>
      </div>
    );
  };

  const getRsvpState = (state, key) => {
    const result = listRsvpState.filter((val) => state === val.state);
    return result.length > 0 ? result[0][key] : null;
  };

  const isAttendingOnStateUpcoming = (rsvpState) => {
    return type === "is_upcoming" && rsvpState === "attending";
  };

  const isAttended = (rsvpState) => {
    return type === "is_today" && rsvpState === "attended";
  };

  const setStateRsvp = (rsvpState) => {
    let state = "";
    if (rsvpState === "not_attending") {
      state = "attending";
    } else if (rsvpState === "attending") {
      state = "attended";
    }

    return state;
  };

  const ModalSuccess = () => {
    return (
      <CustomDialog
        show={showModalSuccess}
        title="Success"
        onHide={() => {
          setShowModalSuccess(false);
          getDataById(id);
        }}
        buttonText="Done"
        content={
          <div>
            <span>Attendance Confirmed.</span>
          </div>
        }
      />
    );
  };

  const onProcess = () => {
    if (isAttended(rsvpState)) return;

    if (type === "is_upcoming") {
      onSubmit();
    } else {
      setShowModal(true);
    }

    if (!passwordRequired && rsvpState === "not_attending") {
      onSubmit();
    }
  };

  const onSubmit = () => {
    if (type === "is_today" && !payload.password) {
      toast.error("Password Wajib diisi", {
        position: toast.POSITION.BOTTOM_LEFT,
      });
      return;
    }
    postEventRsvp({ id, payload })
      .then((response) => {
        if (response.status === 200) {
          setShowModal(false);
          setShowModalSuccess(false);

          if (passwordRequired) {
            setShowModalSuccess(true);
          }
        } else {
          setDataModal({
            ...dataModal,
            isOpen: true,
            message: response.message[0],
          });
        }
      })
      .catch(() => {
        toast.error("Kesalahan pada sistem", {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const ButtonProcess = () => {
    return (
      <div
        onClick={() => {
          if (!isAttendingOnStateUpcoming(rsvpState)) onProcess();
        }}
        disabled={isAttendingOnStateUpcoming(rsvpState)}
        className="btn border-0 w-100 m-bottom"
        style={{
          backgroundColor: isAttendingOnStateUpcoming(rsvpState)
            ? "#EAEAEA"
            : getRsvpState(
                type === "is_today" && rsvpState === "not_attending"
                  ? "attending"
                  : rsvpState,
                "color"
              ),
          color: isAttendingOnStateUpcoming(rsvpState)
            ? "#1A1A1A"
            : isAttended(rsvpState)
            ? "grey"
            : "#FFFFFF",
        }}
      >
        {isAttendingOnStateUpcoming(rsvpState) ? (
          <div>
            <img
              src={Assets.iconCheck}
              width={20}
              className="mr-xs"
              alt="Icon Check"
            />
            You have submitted RSVP
          </div>
        ) : type === "is_today" && rsvpState === "not_attending" ? (
          getRsvpState("attending", "label")
        ) : (
          <>
            {isAttended(rsvpState) ? (
              <img
                src={Assets.iconCheck}
                width={20}
                className="mr-xs"
                alt="Icon Check"
              />
            ) : (
              ""
            )}
            {getRsvpState(rsvpState, "label")}
          </>
        )}
      </div>
    );
  };

  return (
    <div className="event-detail">
      <BaseLayout
        show_menu={false}
        isCustom={true}
        header={
          <Header
            toPath={PageRoutes.event}
            handleClick={() => setShowModalZoom(true)}
            bgImg={`${ApiUtils.validateImgUrl({
              url: thumbnail,
            })}`}
          />
        }
      >
        <>
          <div className="mb-3 font-bold fs-18">{name}</div>
          <SectionEventDate />
          <SectionLocation />
          <SectionBadgeSale />
          <HasLine />
          <SectionEventDescription />
          <HasLine />
          <SectionEventContactInformation />
          <ButtonProcess />
          {!showQrReader ? (
            <Modal
              onHide={!showModal}
              show={showModal}
              size="lg"
              backdrop="static"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Title>Event Attendance</Modal.Title>
              <div className="description">
                Please provide correct passcode by entering manually on the
                field below or scanning qr code provided by event organizer.
              </div>
              <Modal.Body>
                <>
                  <Form.Group as={Col} className="input-password-number">
                    <InputGroup className="mb-3 password">
                      <img
                        src={
                          showPassNumber === "password"
                            ? Assets.iconEye
                            : Assets.iconEyeActive
                        }
                        onClick={() => {
                          setShowPassNumber(
                            showPassNumber === "password" ? "text" : "password"
                          );
                        }}
                        className="pln-img"
                        alt="Icon Eye"
                      />
                      <Form.Control
                        variant="danger"
                        type={showPassNumber}
                        placeholder="Enter Passcode"
                        value={payload.password}
                        onChange={(e) => {
                          setPayload({ ...payload, password: e.target.value });
                        }}
                      />
                      <img
                        src={Assets.iconQrScan}
                        onClick={() => {
                          setShowQrReader(true);
                        }}
                        className="qrscan-img"
                        alt="qrscan_image"
                      />
                    </InputGroup>
                  </Form.Group>
                  <div className="d-grid gap-2">
                    <Button variant="danger" onClick={() => onSubmit()}>
                      Attend
                    </Button>
                    <Button
                      variant="outline-danger"
                      onClick={() => {
                        setShowModal(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </>
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          <ModalSuccess />
          {showQrReader ? (
            <ReaderScan
              showScan={showQrReader}
              setShowScan={() => setShowQrReader(false)}
              setValue={(value) => {
                setShowQrReader(false);
                setPayload({ ...payload, password: value });
              }}
            />
          ) : (
            ""
          )}

          <InformationDialog
            message={dataModal.message}
            closeLabel="OK"
            show={dataModal.isOpen}
            onHide={() => {
              setDataModal({ ...dataModal, isOpen: false });
            }}
          />
        </>
      </BaseLayout>
      {showModalZoom ? (
        <ZoomModal
          open={showModalZoom}
          data={dataZoom}
          toggle={() => setShowModalZoom(!showModalZoom)}
        />
      ) : (
        ""
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataEvent: state.EventSM.dataEvent,
});

const mapDispatchToProps = (dispatch) => ({
  getDataById: dispatch.EventSM.getDataById,
  postEventRsvp: dispatch.EventSM.postEventRsvp,
});

export default connect(mapStateToProps, mapDispatchToProps)(EventDetail);
